import React, { useState, useRef } from "react";
import Popper from '@mui/material/Popper';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Typography } from "@mui/material";

const InfoLinkPopper = ({ title, content, typography, sx }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      display="inline"
      ref={anchorRef}
      textAlign='center'
    >
      <Link
        href="#"
        ref={anchorRef}
        underline="hover"
        sx={{ cursor: 'pointer' }}
        onClick={(e) => e.preventDefault()}
      >
        <Typography typography={typography}>
        {title}
        </Typography>
      </Link>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        disablePortal={false}
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
        sx={sx}
      >
        <Paper elevation={3} sx={{ p: 2 }}>
          {content}
        </Paper>
      </Popper>
    </Box>
  );
};

export default InfoLinkPopper;
